import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback } from 'react';
import preparationProfilesStore from '../../store/preparationProfilesStore';
import { leaveWithoutSaving } from '~/utils/modalConfirmations';
import { ProfilesScrollableList, TProfile } from '~/view/containers/ProfilesList';

export const PreparationSettingProfiles: FC = observer((): ReactElement => {
  const handleCreateProfile = useCallback(() => {
    if (preparationProfilesStore.isEdit) {
      leaveWithoutSaving({ onConfirm: () => preparationProfilesStore.createProfile() });
      return;
    }

    preparationProfilesStore.createProfile();
  }, [preparationProfilesStore.isEdit]);

  const handleProfileClick = useCallback(
    (profile: TProfile) => {
      if (preparationProfilesStore.isEdit) {
        leaveWithoutSaving({ onConfirm: () => preparationProfilesStore.getProfile(profile.id) });
        return;
      }

      preparationProfilesStore.getProfile(profile.id);
    },
    [preparationProfilesStore.isEdit]
  );

  const handleProfileNameChange = useCallback((profile: TProfile) => {
    preparationProfilesStore.changeSelectedProfile({ name: profile.name });
    return true;
  }, []);

  return (
    <ProfilesScrollableList
      loading={preparationProfilesStore.isLoading}
      profiles={preparationProfilesStore.profiles}
      onAddProfile={handleCreateProfile}
      selectProfile={handleProfileClick}
      onUpdateName={handleProfileNameChange}
      selectedProfileId={preparationProfilesStore.selectedProfile.id}
    />
  );
});
